import React from "react";

function Portfolio() {
  return (
    <div className="container mt-10" id="my_services_section">
      <div className="w-full">
        <div className="flex flex-col space-y-3.5 items-center justify-center">
          <div className="border rounded-2xl border-gray border-opacity-20 w-full p-6 md:p-10">
            <p
              data-aos="fade-down"
              className="text-2xl font-bold text-center text-gray mb-3"
            >
              Airbnb Properties
            </p>
            <p
              data-aos="fade-down"
              data-aos-delay="100"
              className="text-base font-bold leading-normal text-center text-gray text-opacity-90"
            >
              2 Units - Dayton, Ohio
            </p>
            <div className="mt-10">
              <p
                data-aos="fade-down"
                data-aos-delay="150"
                className="text-2xl font-bold text-center text-gray"
              >
                Statistics:
              </p>
            </div>
            <div className="flex justify-center gap-2.5 flex-wrap mt-6">
              <div
                data-aos="fade-down"
                data-aos-delay="200"
                className="p-5 w-full md:w-auto px-10 bg-orange text-white rounded-2xl text-center font-bold text-sm"
              >
                Property Type: Duplex
              </div>
              <div
                data-aos="fade-down"
                data-aos-delay="250"
                className="p-5 w-full md:w-auto px-10 bg-purple text-white rounded-2xl text-center font-bold text-sm"
              >
                Property Value: $120,000
              </div>
              <div
                data-aos="fade-down"
                data-aos-delay="300"
                className="p-5 w-full md:w-auto px-10 bg-yellow text-gray rounded-2xl text-center font-bold text-sm"
              >
                Market Rents: $750/850
              </div>
              <div
                data-aos="fade-down"
                data-aos-delay="350"
                className="p-5 w-full md:w-auto px-10 bg-orange text-white rounded-2xl text-center font-bold text-sm "
              >
                Average Earnings: $1,400-2500/mo/unit
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
